import React, { useState } from 'react';
import { useQuery, useMutation } from 'react-query';
import { endpoints, fetcher } from 'services';
import { message } from 'antd';
import { MSG } from 'commons/constants';

const useFileInfo = (param: FileInfoReqDto) => {
  /* ======================================================
   * state
   * ====================================================== */
  const [fileInfo, setFileInfo] = useState<FileInfoDto>();
  
  /* ======================================================
   * hooks
   * ====================================================== */

  const { isLoading } = useQuery(
    [endpoints.file.info],
    () =>
      fetcher.file.postFileInfo(param),
    {
      onSuccess: (res: FileInfoResDto) => {
        switch (res.code) {
          case 200:
            setFileInfo(res.result?.file);
            break;
          case 400:
          default:
            break;
        }
      },
    },
  );
 

  return { isLoading, fileInfo };
};

export default useFileInfo;
